import React, { useEffect, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerMyDataImmo } from '../../../data/modules/my-materials-header';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import { useNavigate, useParams } from 'react-router';
import { makeStyles, Typography } from '@material-ui/core';
import { AppBar, Autocomplete, Card, CardHeader, Chip, Collapse, FormControl, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { AntTab, AntTabs } from '../../../components/ant-tab';
import Spacer from '../../../components/Spacer';
import PlanningMissionService from '../../../services/PlanningMissionService';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import IndemnityMissionService from '../../../services/IndemnityMisisonService';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px !important",
    marginTop: "1.5%",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    width: "98%",
  },
  tab: {
    width: "80%",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
}));

const IndemnityMissionAdd = () => {
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [value, setValue] = useState(0);
    const [missionData, setMissionData] = useState({});
    const [destinations, setDestinations] = useState([]);
    const [openRows, setOpenRows] = useState({});
    const [message, setMessage] = useState({
            open: false,
            color: 'green',
            messageInfo: '',
          });
    const { open, color, messageInfo } = message;
    const classes = useStyles();
    const navigate = useNavigate();
    const { id } = useParams();
    const missionId = id ? id : null;

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
      }

      useEffect(() => {
        async function fetchMissionDetails() {
            // setOpenLoadingSimpleBackdrop(true);
            try {
              const result = await PlanningMissionService.getdetails(missionId); //recupérer les informations de la mission
              if (result?.data?.length) {
                const mission = result.data[0];
                setMissionData(mission || {});
                if (mission.agedref?.mission_planning_agenda_id) {
                    
                    const resultAgenda = await IndemnityMissionService.getDestinaitonsIndemnity(mission.agedref?.mission_planning_agenda_id); //recupérer les informations de l'agenda de la mission
                    console.log(resultAgenda)
                    if (resultAgenda?.data?.length) {
                        const agenda = resultAgenda.data;
                        console.log(agenda)
                      //  setDestinations(agenda);
                    //    agenda.map((destination) => {
                    //     setFormValues((prev) => ({
                    //       ...prev,
                    //       agenda_id : mission.agedref?.mission_planning_agenda_id,
                    //       timesheet: [
                    //         ...prev.timesheet,
                    //         {
                    //           destination_id: destination.mission_destination_id,
                    //           km: destination.transport_km,
                    //           details_id : destination.missionnaries.map( missionnary => missionnary.mission_planning_agenda_details_id),
                    //         },
                    //       ],
                    //     }));
                    //     });
    
                        setOpenLoadingSimpleBackdrop(false);
                    }
                }
                    
            }} catch(error) {
                setMessage({ open: true, color: 'red', messageInfo: error.message });
                
                setOpenLoadingSimpleBackdrop(false);
            }
        }
        fetchMissionDetails();
    
        }, [missionId]);

         useEffect(() => {
            function handleColapse() {
              const newOpenRows = {};
              destinations.forEach((_, index) => {
                newOpenRows[index] = true;
              });
              setOpenRows(newOpenRows);
            }
        
            handleColapse();
          }, [destinations]);

        const formatDate = (dateString) => {
            const date = new Date(dateString);
        
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
        
            return `${day}/${month}/${year}`;
          };

          const handleToggleRow = (index) => {
            setOpenRows((prevState) => ({
              ...prevState,
              [index]: !prevState[index],
            }));
          };

    return (
        <MainContainer {...headerMyDataImmo}>
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} /> 
      
      <AppBar position="static" color="default" className={classes.AppBar}>
          <AntTabs
            value={value}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <AntTab disableRipple label="Decompte des indemnités de mission" className={classes.tab} />
          </AntTabs>
        </AppBar>
          <Spacer y={2} />

          <Grid container xs={12} spacing={2} justifyContent="center" display="flex" flexDirection="row"
        sx={{margin: "0.25%",}}
      >

        <Grid item xs={12} sm={6} md={4}>
        
           <Grid item xs={12} sm={6} md={6}>
           <label className={classes.labelPosition}>
                  Réference de la mission
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.reference}
              name="name"
              type="text"
              style={{ width: '300px' }}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
           <label className={classes.labelPosition}>
           Lieu de destination
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField   
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.lieu}
              name="name"
              type="text"
              style={{ width: '300px' }}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        <Grid item xs={12} sm={6} md={6} >
        <label className={classes.labelPosition}>
        Moyen de transport souhaité
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.transport}
              name="code"
              type="text"
              style={{ width: '300px'}}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
        <Grid item xs={12}  >
        <label className={classes.labelPosition}>
        Objet de la mission
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.mission_title}
              name="code"
              type="text"
              fullWidth
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>     
        <Grid item xs={12} >
        <label className={classes.labelPosition}>
        Missionnaires
                </label>
                <Spacer y={0.2}></Spacer>
                <TextField
                    multiline
                    rows={4}
                    value={missionData?.missionnary ? missionData?.missionnary.map((obj) => `- ${obj.nom}`).join("\n") : []} // Format objects into text
                    variant="outlined"
                    fullWidth
                    disabled
                  />
        </Grid>
       </Grid>
        <Spacer y={2} />
        <Paper variant="outlined" className={classes.paper}>
              
              <Grid container xs={12} sx={{marginBottom: 1}} >
              <Grid item xs={4} >
                <CardHeader title={"Agenda de la mission"} style={{ color: '#1976d2' }}></CardHeader>
              </Grid>
              </Grid>
              <Grid item xs={12} variant="outlined">
              <TableContainer  sx={{boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;", borderRadius: "8px"}}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableRow sx={{fontStyle: "bold"}}>
              <TableCell  sx={{ width: 10 }}>
              <IconButton
                                    size="small"
                                    // onClick={() => handleToggleRow(index)}
                                    onClick={() => handleToggleRow(0)}
                                    
                                   >
                                    {/* {openRows[index] ? <KeyboardArrowUp color="info"/> : <KeyboardArrowDown color="info"/>} */}
                                    {openRows[0] ? <KeyboardArrowUp color="info"/> : <KeyboardArrowDown color="info"/>}
                                  </IconButton >
                                  </TableCell>
                                  <TableCell>
                                  <Typography>RANDRY Miranto Nantenaina</Typography></TableCell>
                                  </TableRow>
               <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                  {/* <Collapse in={openRows[index]} timeout="auto" unmountOnExit> */}
                  <Collapse in={openRows[0]} timeout="auto" unmountOnExit>
                  <Spacer y={1} />
                     <Table size="small" variant="outlined" aria-label="sous-tableau" sx={{ marginTop: "1%", marginBottom: "2%", boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;", borderRadius: "6px", }}>
                        <TableRow sx={{fontStyle: "bold"}}>
                         
                            <TableCell sx={{fontWeight: "bold", width: "20%"}}>Date</TableCell>
                            <TableCell sx={{fontWeight: "bold", width: "20%"}}>Heure</TableCell>
                            <TableCell sx={{fontWeight: "bold", width: "20%"}}>Lieu</TableCell>
                            <TableCell sx={{fontWeight: "bold", width: "20%"}}>Nombre de jours</TableCell>
                            <TableCell sx={{fontWeight: "bold", width: "20%"}}>Indemnité</TableCell>
                            <TableCell sx={{fontWeight: "bold", width: "20%"}}>Montant</TableCell>
                          </TableRow>
                        <TableBody>
                        {destinations.map((destination, index) => (
                            <TableRow>
                                <TableCell>
                                    <label className={classes.labelPosition} style={{color: "grey", fontSize: "16px"}}>
                                    { formatDate(destination.date_begin)} - {formatDate(destination.date_end)}  
                                    </label>                       
                                </TableCell>  
                                <TableCell>
                                    <label className={classes.labelPosition} style={{color: "grey", fontSize: "16px"}}>
                                    {destination.heure_begin} - {destination.heure_end}
                                    </label>
                                </TableCell>
                                 <TableCell>
                                <label className={classes.labelPosition} style={{color: "grey", fontSize: "16px"}}>
                                    {/* {destination.libelle === null ? `${destination.depart} - ${destination.arriver}` : destination.libelle} */}
                                    {destination.type === "DR" 
                                    ? `${destination.depart} - ${destination.arriver}`  
                                    : (destination.activite === "mis" 
                                        ? destination.region  
                                        : destination.direction_code
                                    ) }
                                </label>
                                </TableCell>
                                <TableCell>
                                <FormControl fullWidth variant="outlined" size="small">
                                              <Autocomplete id="tags-outlined"
                                                options={destination?.missionnaries || []}
                                                getOptionLabel={(option) => (option ? option.name.toString() : '')}
                                                filterSelectedOptions
                                                value={destination?.missionnaries}
                                                multiple
                                                readOnly
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    fullWidth
                                                    id="outlined-basic"
                                                    size="small"
                                                    variant="outlined"
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                    </TableCell>
                                    <TableCell>
                                  { destination.type === "DM" ?   <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" color="info"/> :  <Chip icon={<TimeToLeaveIcon />} label="Délai de route" variant="outlined" color="info"/> }   
                                        </TableCell>
                                        <TableCell>
                                            <FormControl fullWidth variant="outlined" size="small">
                                                 <TextField
                                                    id="outlined-number"
                                                    label="Km"
                                                    type="number"
                                                    slotProps={{
                                                        inputLabel: {
                                                        shrink: true,
                                                        },
                                                    }}
                                                    size='small'                                                          
                                                   
                                                    />
                                                </FormControl>
                                            </TableCell>
                            </TableRow>
                          ))}

                            </TableBody>
                        </Table>
                   
                    </Collapse>
                    </TableCell>
                </TableRow>
                </Table>
                </TableContainer>
                </Grid>
                </Paper>
        
        </Grid>
            </MainContainer>
    );
}

export default IndemnityMissionAdd;